import * as React from 'react';
import {useDispatch} from 'react-redux';

import {navigateAction} from '~/actions/navigateActions';
import routeByName from '~/constants/routes';
import useModalById from '~/customHooks/useModalById';
import {MODAL_COMPLETE_PROFILE} from '~/rootStore/modals/modalsIds';

import ModalBase from '../ModalBase';
import ModalBaseContent from '../ModalBaseContent';
import image from './img/complete-profile.svg';

const ModalCompleteProfile: React.FC = () => {
  const {isOpen, close: onClose} = useModalById(MODAL_COMPLETE_PROFILE);

  const dispatch = useDispatch();
  const handleActionClick = () => {
    onClose();
    dispatch(navigateAction(routeByName.createProfile));
  };

  return (
    <ModalBase showCloseButton open={isOpen} onClose={onClose}>
      <ModalBaseContent
        p={2}
        image={image}
        title="Complete Profile"
        description="Complete your profile and text providers instantly"
        actionButtonText="Complete Profile"
        onClickActionButton={handleActionClick}
      />
    </ModalBase>
  );
};

export default ModalCompleteProfile;
